<template>
	<v-form-group :label="label" :id="elementId" :cols="cols" :wrapped="wrapped" :error-message="errorMessage">
		<input
			class="form-control"
			:type="type"
			:id="elementId"
			:value="mask.format ? masked : value"
			:maxlength="maxLength"
			:placeholder="placeholder"
			:style="styles"
			:disabled="disabled"
			@input="updateModel"
			@keypress="preventKeys"
			ref="input">
	</v-form-group>
</template>

<script>
	import Base from './base';
	import VFormGroup from './form-group';
	import Masker from './masker';

	export default {
		extends: Base,

		props: {
			maxlength: { default: null },
			placeholder: { default: null },
			styles: { default: null },
			disabled: { default: false },
			type: { default: 'text' }
		},

		components: { VFormGroup },

		computed: {
			maxLength() {
				return this.mask.format ? this.mask.format.length : this.maxlength;
			},

			masked() {
				let maskedValue = Masker.maskit(this.mask, this.value.toString());

				if (this.mask.change) {
					this.$emit('input', maskedValue);
				}

				return maskedValue;
			}
		},

		methods: {
			preventKeys($event) {
				if (this.mask.format && $event.keyCode !== 13) {
					Masker.preventKeys($event, this.mask, this.value);
				}
			},

			updateModel($event) {
				let value = $event.target.value;

				if (this.mask.format && !this.mask.change) {
					value = Masker.unmaskit(this.mask, value);
				}

				this.$emit('input', value);

				setTimeout(() => {
					if (this.mask.format) {
						this.$refs.input.selectionStart = this.$refs.input.selectionEnd = this.mask.format.length;
					}
				}, 0);
			}
		}
	};
</script>


// WEBPACK FOOTER //
// input.vue?58ea027a